/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./CheckProduct.vue?vue&type=template&id=36621137&scoped=true&"
import script from "./CheckProduct.vue?vue&type=script&lang=js&"
export * from "./CheckProduct.vue?vue&type=script&lang=js&"
import style0 from "./CheckProduct.vue?vue&type=style&index=0&id=36621137&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36621137",
  null
  
)

export default component.exports